<template>
  <div id="contenedor-default-contrato" class="bkground">
    <!-- Estado cargando -->
    <template v-if="$apollo.loading">
      <v-row>
        <v-col cols="12" md="4">
          <v-skeleton-loader type="card"></v-skeleton-loader>
        </v-col>
        <v-col cols="12" md="8">
          <v-skeleton-loader type="card"></v-skeleton-loader>
        </v-col>
      </v-row>
    </template>

    <!-- Contenido -->
    <template v-else>
      <v-row>
        <!-- Columna Izquierda -->
        <v-col cols="12" md="4">
          <!-- Card Información General -->
          <v-card class="rounded-lg mb-4">
            <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
              <v-icon left small color="white">mdi-file-document-outline</v-icon>
              Información General
            </v-card-title>
            <v-card-text class="pt-4">
              <v-list dense class="transparent">
                <v-list-item class="px-0">
                  <v-list-item-icon class="mr-3">
                    <v-icon small color="grey">mdi-pound</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption">
                      Número de Contrato
                    </v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ getContrato.numero }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="px-0">
                  <v-list-item-icon class="mr-3">
                    <v-icon small color="grey">mdi-clipboard-check-outline</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption">
                      ¿Cómo se Contrató?
                    </v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ getContrato.comoSeContrato }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="px-0">
                  <v-list-item-icon class="mr-3">
                    <v-icon small color="grey">mdi-domain</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption">
                      Contratista
                    </v-list-item-subtitle>
                    <v-list-item-title class="font-weight-medium">
                      {{ getContrato.contratista.nombreRazonSocial }}
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item class="px-0">
                  <v-list-item-icon class="mr-3">
                    <v-icon small color="grey">mdi-bank</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-subtitle class="text-caption">
                      ¿Es Obra Financiada?
                    </v-list-item-subtitle>
                    <v-list-item-title>
                      <v-chip
                        x-small
                        :color="getContrato.esObraFinanciada ? 'success' : 'grey'"
                        text-color="white">
                        {{ getContrato.esObraFinanciada ? 'Sí' : 'No' }}
                      </v-chip>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

              <v-divider class="my-3"></v-divider>

              <div>
                <span class="text-caption grey--text">Objeto del Contrato</span>
                <p class="text-body-2 mt-1 mb-0">{{ getContrato.meta }}</p>
              </div>
            </v-card-text>
          </v-card>

          <!-- Card Fechas -->
          <v-card class="rounded-lg mb-4">
            <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
              <v-icon left small color="white">mdi-calendar-range</v-icon>
              Fechas
            </v-card-title>
            <v-card-text class="pt-4">
              <v-timeline dense align-top>
                <v-timeline-item
                  small
                  color="primary"
                  icon="mdi-file-sign">
                  <div>
                    <span class="text-caption grey--text">Fecha de Contrato</span>
                    <div class="font-weight-medium">
                      {{ $moment(getContrato.fecha).format('DD/MM/YYYY') }}
                    </div>
                  </div>
                </v-timeline-item>

                <v-timeline-item
                  small
                  :color="getConveniosPlazo.length > 0 ? 'grey' : 'success'"
                  icon="mdi-play">
                  <div>
                    <div class="d-flex align-center mb-1">
                      <span class="text-caption grey--text">Fecha de Inicio</span>
                      <v-chip
                        v-if="getConveniosPlazo.length > 0"
                        x-small
                        color="grey"
                        text-color="white"
                        class="ml-2">
                        Original
                      </v-chip>
                    </div>
                    <div
                      class="font-weight-medium"
                      :class="
                        getConveniosPlazo.length > 0
                          ? 'text-decoration-line-through grey--text'
                          : ''
                      ">
                      {{ $moment(getContrato.fechaInicio).format('DD/MM/YYYY') }}
                    </div>
                    <div v-if="getFechaInicioVigente" class="mt-2">
                      <v-chip
                        x-small
                        color="success"
                        text-color="white"
                        class="mb-1">
                        <v-icon left x-small>mdi-check-circle</v-icon>
                        Vigente
                      </v-chip>
                      <div class="font-weight-bold success--text text-body-1">
                        {{ $moment(getFechaInicioVigente).format('DD/MM/YYYY') }}
                      </div>
                    </div>
                  </div>
                </v-timeline-item>

                <v-timeline-item
                  small
                  :color="getConveniosPlazo.length > 0 ? 'grey' : 'warning'"
                  icon="mdi-flag-checkered">
                  <div>
                    <div class="d-flex align-center mb-1">
                      <span class="text-caption grey--text">Fecha de Término</span>
                      <v-chip
                        v-if="getConveniosPlazo.length > 0"
                        x-small
                        color="grey"
                        text-color="white"
                        class="ml-2">
                        Original
                      </v-chip>
                    </div>
                    <div
                      class="font-weight-medium"
                      :class="
                        getConveniosPlazo.length > 0
                          ? 'text-decoration-line-through grey--text'
                          : ''
                      ">
                      {{ $moment(getContrato.fechaTermino).format('DD/MM/YYYY') }}
                    </div>
                    <div v-if="getFechaTerminoVigente" class="mt-2">
                      <v-chip
                        x-small
                        color="warning"
                        text-color="white"
                        class="mb-1">
                        <v-icon left x-small>mdi-check-circle</v-icon>
                        Vigente
                      </v-chip>
                      <div class="font-weight-bold warning--text text-body-1">
                        {{ $moment(getFechaTerminoVigente).format('DD/MM/YYYY') }}
                      </div>
                    </div>
                  </div>
                </v-timeline-item>
              </v-timeline>

              <!-- Días restantes -->
              <div class="text-center mt-2">
                <v-chip
                  small
                  :color="getColorDiasRestantes"
                  text-color="white">
                  <v-icon left x-small>mdi-clock-outline</v-icon>
                  {{ getDiasRestantes }}
                </v-chip>
              </div>

              <template v-if="getConveniosPlazo.length > 0">
                <v-divider class="my-3"></v-divider>
                <div class="text-center">
                  <v-chip
                    small
                    color="orange"
                    text-color="white">
                    <v-icon left small>mdi-file-document-edit</v-icon>
                    {{ getConveniosPlazo.length }}
                    convenio{{ getConveniosPlazo.length > 1 ? 's' : '' }} de plazo
                  </v-chip>
                </div>
              </template>
            </v-card-text>
          </v-card>

          <!-- Card Estado y Etiquetas -->
          <v-card class="rounded-lg">
            <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
              <v-icon left small color="white">mdi-tag-multiple</v-icon>
              Estado y Etiquetas
            </v-card-title>
            <v-card-text class="pt-4">
              <div class="mb-4">
                <span class="text-caption grey--text d-block mb-2">Estatus del Contrato</span>
                <actualizar-estatus
                  v-if="mixValidaScopesActions(2)"
                  :id-contrato="getContrato.id"
                  :estatus="getEstatus"
                  :id-contrato-estatus="getContrato.idContratoEstatus">
                </actualizar-estatus>
              </div>

              <v-divider class="mb-4"></v-divider>

              <div>
                <span class="text-caption grey--text d-block mb-2">Etiquetas</span>
                <div class="d-flex flex-wrap gap-2">
                  <v-chip
                    v-for="{id, etiqueta} in getContrato.etiquetas"
                    :key="id"
                    small
                    :color="etiqueta.color"
                    :dark="etiqueta.esTextoClaro"
                    class="mr-1 mb-1">
                    {{ etiqueta.nombre }}
                  </v-chip>
                  <agregar-etiquetas
                    v-if="mixValidaScopesActions(2)"
                    :id-referencia="getContrato.id"
                    modulo="CONTRATOS"
                    :etiquetas-agregadas="getContrato.etiquetas.map(({idEtiqueta}) => idEtiqueta)">
                  </agregar-etiquetas>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>

        <!-- Columna derecha -->
        <v-col cols="12" md="8">
          <!-- Card Resumen Financiero -->
          <v-card class="rounded-lg mb-4">
            <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
              <v-icon left small color="white">mdi-currency-usd</v-icon>
              Resumen Financiero
            </v-card-title>
            <v-card-text class="pt-4">
              <!-- Totales principales -->
              <v-row class="text-center">
                <v-col cols="12" md="4">
                  <div class="pa-4 rounded-lg" style="background: rgba(0,0,0,0.02);">
                    <div class="d-flex align-center justify-center mb-1">
                      <span class="text-caption grey--text">Importe</span>
                      <v-chip
                        v-if="getConveniosMonto.length > 0"
                        x-small
                        class="ml-2"
                        color="orange"
                        outlined>
                        {{ getConveniosMonto.length }}
                        convenio{{ getConveniosMonto.length > 1 ? 's' : '' }}
                      </v-chip>
                    </div>
                    <div class="text-h6 font-weight-bold primary--text">
                      {{ getImporteOriginal | currency }}
                    </div>
                    <template v-if="getConveniosMontoAcumulado.importe !== 0">
                      <v-divider class="my-1"></v-divider>
                      <div class="text-caption" :class="getClaseConvenioImporte">
                        <v-icon x-small :color="getColorConvenioImporte">
                          {{
                            getConveniosMontoAcumulado.importe > 0
                              ? 'mdi-arrow-up'
                              : 'mdi-arrow-down'
                          }}
                        </v-icon>
                        {{ getConveniosMontoAcumulado.importe | currency }}
                      </div>
                      <div class="text-body-2 font-weight-bold mt-1">
                        {{ getImporteTotalConConvenios | currency }}
                      </div>
                    </template>
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="pa-4 rounded-lg" style="background: rgba(0,0,0,0.02);">
                    <div class="text-caption grey--text mb-1">IVA</div>
                    <div class="text-h6 font-weight-bold">
                      {{ getContrato.iva | currency }}
                    </div>
                    <template v-if="getConveniosMontoAcumulado.iva !== 0">
                      <v-divider class="my-1"></v-divider>
                      <div class="text-caption" :class="getClaseConvenioIva">
                        <v-icon x-small :color="getColorConvenioIva">
                          {{
                            getConveniosMontoAcumulado.iva > 0
                              ? 'mdi-arrow-up'
                              : 'mdi-arrow-down'
                          }}
                        </v-icon>
                        {{ getConveniosMontoAcumulado.iva | currency }}
                      </div>
                      <div class="text-body-2 font-weight-bold mt-1">
                        {{ getIvaTotalConConvenios | currency }}
                      </div>
                    </template>
                  </div>
                </v-col>
                <v-col cols="12" md="4">
                  <div class="pa-4 rounded-lg success lighten-5">
                    <div class="text-caption grey--text mb-1">Total</div>
                    <div class="text-h6 font-weight-bold success--text">
                      {{ getContrato.total | currency }}
                    </div>
                    <template v-if="getConveniosMontoAcumulado.total !== 0">
                      <v-divider class="my-1"></v-divider>
                      <div class="text-caption" :class="getClaseConvenioTotal">
                        <v-icon x-small :color="getColorConvenioTotal">
                          {{
                            getConveniosMontoAcumulado.total > 0
                              ? 'mdi-arrow-up'
                              : 'mdi-arrow-down'
                          }}
                        </v-icon>
                        {{ getConveniosMontoAcumulado.total | currency }}
                      </div>
                      <div class="text-body-2 font-weight-bold mt-1">
                        {{ getTotalConConvenios | currency }}
                      </div>
                    </template>
                  </div>
                </v-col>
              </v-row>

              <!-- Desglose Obra Financiada -->
              <v-expansion-panels
                v-if="getContrato.esObraFinanciada"
                v-model="panelFinanciadoAbierto"
                flat
                class="mt-4">
                <v-expansion-panel>
                  <v-expansion-panel-header class="px-0">
                    <div class="d-flex align-center">
                      <v-icon left small color="primary">mdi-bank</v-icon>
                      <span class="font-weight-medium">Desglose de Obra Financiada</span>
                    </div>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-simple-table dense>
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left">Concepto</th>
                            <th class="text-right">Porcentaje</th>
                            <th class="text-right">Importe</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr>
                            <td>Costo Directo</td>
                            <td class="text-right">-</td>
                            <td class="text-right">
                              <div>{{ getContrato.importeCostoDirecto | currency }}</div>
                              <template
                                v-if="getConveniosFinanciadoAcumulado.importeCostoDirecto !== 0">
                                <div
                                  class="text-caption mt-1"
                                  :class="getClaseConvenioCostoDirecto">
                                  <v-icon x-small :color="getColorConvenioCostoDirecto">
                                    {{
                                      getConveniosFinanciadoAcumulado.importeCostoDirecto > 0
                                        ? 'mdi-arrow-up'
                                        : 'mdi-arrow-down'
                                    }}
                                  </v-icon>
                                  {{
                                    getConveniosFinanciadoAcumulado.importeCostoDirecto | currency
                                  }}
                                </div>
                                <div class="text-body-2 font-weight-bold mt-1">
                                  {{ getImporteCostoDirectoConConvenios | currency }}
                                </div>
                              </template>
                            </td>
                          </tr>
                          <tr>
                            <td>Indirectos</td>
                            <td class="text-right">
                              {{ getContrato.porcentajeCostoIndirectos }}%
                            </td>
                            <td class="text-right">
                              <div>{{ getContrato.importeCostoIndirectos | currency }}</div>
                              <template
                                v-if="getConveniosFinanciadoAcumulado.importeCostoIndirectos !== 0">
                                <div
                                  class="text-caption mt-1"
                                  :class="getClaseConvenioCostoIndirectos">
                                  <v-icon x-small :color="getColorConvenioCostoIndirectos">
                                    {{
                                      getConveniosFinanciadoAcumulado.importeCostoIndirectos > 0
                                        ? 'mdi-arrow-up'
                                        : 'mdi-arrow-down'
                                    }}
                                  </v-icon>
                                  {{
                                    getConveniosFinanciadoAcumulado.importeCostoIndirectos
                                      | currency
                                  }}
                                </div>
                                <div class="text-body-2 font-weight-bold mt-1">
                                  {{ getImporteCostoIndirectosConConvenios | currency }}
                                </div>
                              </template>
                            </td>
                          </tr>
                          <tr>
                            <td>Utilidad</td>
                            <td class="text-right">
                              {{ getContrato.porcentajeUtilidad }}%
                            </td>
                            <td class="text-right">
                              <div>{{ getContrato.importeUtilidad | currency }}</div>
                              <template
                                v-if="getConveniosFinanciadoAcumulado.importeUtilidad !== 0">
                                <div class="text-caption mt-1" :class="getClaseConvenioUtilidad">
                                  <v-icon x-small :color="getColorConvenioUtilidad">
                                    {{
                                      getConveniosFinanciadoAcumulado.importeUtilidad > 0
                                        ? 'mdi-arrow-up'
                                        : 'mdi-arrow-down'
                                    }}
                                  </v-icon>
                                  {{ getConveniosFinanciadoAcumulado.importeUtilidad | currency }}
                                </div>
                                <div class="text-body-2 font-weight-bold mt-1">
                                  {{ getImporteUtilidadConConvenios | currency }}
                                </div>
                              </template>
                            </td>
                          </tr>
                          <tr>
                            <td>Cargos Adicionales</td>
                            <td class="text-right">
                              {{ getContrato.porcentajeCargosAdicionales }}%
                            </td>
                            <td class="text-right">
                              <div>{{ getContrato.importeCargosAdicionales | currency }}</div>
                              <template
                                v-if="
                                  getConveniosFinanciadoAcumulado.importeCargosAdicionales !== 0
                                ">
                                <div
                                  class="text-caption mt-1"
                                  :class="getClaseConvenioCargosAdicionales">
                                  <v-icon x-small :color="getColorConvenioCargosAdicionales">
                                    {{
                                      getConveniosFinanciadoAcumulado.importeCargosAdicionales > 0
                                        ? 'mdi-arrow-up'
                                        : 'mdi-arrow-down'
                                    }}
                                  </v-icon>
                                  {{
                                    getConveniosFinanciadoAcumulado.importeCargosAdicionales
                                      | currency
                                  }}
                                </div>
                                <div class="text-body-2 font-weight-bold mt-1">
                                  {{ getImporteCargosAdicionalesConConvenios | currency }}
                                </div>
                              </template>
                            </td>
                          </tr>
                          <tr class="grey lighten-4">
                            <td class="font-weight-bold">
                              Subtotal (Sin Financiamiento)
                            </td>
                            <td class="text-right">-</td>
                            <td class="text-right font-weight-bold">
                              {{ getContrato.importeTotal | currency }}
                            </td>
                          </tr>
                          <tr>
                            <td>Costo Financiero</td>
                            <td class="text-right">
                              {{ getContrato.porcentajeCostoFinanciero }}%
                            </td>
                            <td class="text-right">
                              <div>{{ getContrato.importeCostoFinanciero | currency }}</div>
                              <template
                                v-if="getConveniosFinanciadoAcumulado.importeCostoFinanciero !== 0">
                                <div
                                  class="text-caption mt-1"
                                  :class="getClaseConvenioCostoFinanciero">
                                  <v-icon x-small :color="getColorConvenioCostoFinanciero">
                                    {{
                                      getConveniosFinanciadoAcumulado.importeCostoFinanciero > 0
                                        ? 'mdi-arrow-up'
                                        : 'mdi-arrow-down'
                                    }}
                                  </v-icon>
                                  {{
                                    getConveniosFinanciadoAcumulado.importeCostoFinanciero
                                      | currency
                                  }}
                                </div>
                                <div class="text-body-2 font-weight-bold mt-1">
                                  {{ getImporteCostoFinancieroConConvenios | currency }}
                                </div>
                              </template>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-card-text>
          </v-card>

          <!-- Card Ubicaciones -->
          <v-card class="rounded-lg mb-4">
            <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
              <v-icon left small color="white">mdi-map-marker</v-icon>
              Ubicaciones
              <v-chip
                x-small
                color="white"
                text-color="grey darken-3"
                class="ml-2">
                {{ getUbicacionesCount }}
              </v-chip>
              <v-spacer></v-spacer>
              <v-btn
                v-if="mixValidaScopesActions(2)"
                x-small
                color="white"
                text
                @click="mostrarAgregarUbicacion = !mostrarAgregarUbicacion">
                <v-icon left x-small>mdi-plus</v-icon>
                Agregar
              </v-btn>
            </v-card-title>
            <v-card-text class="pt-4">
              <ubicaciones :id-contrato="$route.params.idContrato"></ubicaciones>
            </v-card-text>
          </v-card>

          <!-- Card Obras Asociadas -->
          <v-card class="rounded-lg">
            <v-card-title class="grey darken-3 white--text text-subtitle-1 py-3">
              <v-icon left small color="white">mdi-office-building</v-icon>
              Obras Asociadas
              <v-chip
                x-small
                color="white"
                text-color="grey darken-3"
                class="ml-2">
                {{ getContrato.obras ? getContrato.obras.length : 0 }}
              </v-chip>
            </v-card-title>
            <v-card-text class="pa-0">
              <template v-if="getContrato.obras && getContrato.obras.length > 0">
                <v-data-table
                  :headers="headers"
                  :items="getContrato.obras"
                  disable-pagination
                  disable-filtering
                  hide-default-footer
                  class="elevation-0">
                  <template v-slot:[`item.obra.clave`]="{ item }">
                    <span class="font-weight-medium primary--text">{{ item.obra.clave }}</span>
                  </template>
                  <template v-slot:[`item.obra.tipo`]="{ item }">
                    <v-chip small :color="item.obra.tipo.color">
                      {{ item.obra.tipo.descripcion }}
                    </v-chip>
                  </template>
                  <template v-slot:[`item.obra.meta`]="{ item }">
                    <span class="text-body-2">{{ item.obra.meta }}</span>
                  </template>
                </v-data-table>
              </template>
              <template v-else>
                <div class="text-center py-10">
                  <v-icon size="60" color="grey lighten-2">mdi-office-building-outline</v-icon>
                  <p class="text-body-1 grey--text mt-4 mb-0">
                    Este contrato no tiene obras registradas
                  </p>
                </div>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <!-- Diálogo Agregar Ubicación georeferenciada -->
    <v-dialog
      v-model="mostrarAgregarUbicacion"
      width="650"
      persistent>
      <agregar-ubicaciones
        :id-contrato="$route.params.idContrato"
        v-on:cerrar="cerrarAgregarGeolocalizacion">
      </agregar-ubicaciones>
    </v-dialog>
  </div>
</template>

<script>

import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import ActualizarEstatus from '@/components/administracion/contratos/contrato/ActualizarEstatus.vue';
import AgregarEtiquetas from '@/components/administracion/etiquetas/Agregar.vue';
import AgregarUbicaciones from '@/components/administracion/contratos/contrato/ubicaciones/Agregar.vue';
import Ubicaciones from './Ubicaciones.vue';

export default {
  name: 'DefaultContrato',
  components: {
    ActualizarEstatus,
    AgregarEtiquetas,
    AgregarUbicaciones,
    Ubicaciones,
  },
  data() {
    return {
      mostrarAgregarUbicacion: false,
      panelFinanciadoAbierto: 0,
      headers: [
        {
          text: 'Clave',
          class: 'grey--text text--darken-3 font-weight-bold',
          align: 'start',
          value: 'obra.clave',
          width: '120',
          sortable: false,
        },
        {
          text: 'Tipo',
          class: 'grey--text text--darken-3 font-weight-bold',
          value: 'obra.tipo',
          width: '150',
          sortable: false,
        },
        {
          text: 'Meta',
          class: 'grey--text text--darken-3 font-weight-bold',
          value: 'obra.meta',
          sortable: false,
        },
      ],
    };
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
  },
  methods: {
    cerrarAgregarGeolocalizacion() {
      this.mostrarAgregarUbicacion = false;
    },
    formatoFecha(fecha) {
      return new Date(`${fecha} 00:00:0`).toLocaleDateString();
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    getConveniosMonto() {
      if (!this.contrato?.convenios) return [];
      return this.contrato.convenios.filter(({ tipo }) => {
        if (!tipo) return false;
        return tipo.substr(0, 5) === 'MONTO' || tipo === 'PLAZO - MONTO AMPLIACIÓN';
      });
    },
    getConveniosPlazo() {
      if (!this.contrato?.convenios) return [];

      return this.contrato.convenios.filter(({ tipo, fechaInicio, fechaTermino }) => {
        if (!tipo) return false;

        const modificaPlazo = tipo === 'PLAZO'
          || tipo === 'REPROGRAMACIÓN'
          || tipo === 'FINANCIERO'
          || tipo === 'PLAZO - MONTO AMPLIACIÓN';

        return modificaPlazo && (fechaInicio || fechaTermino);
      });
    },
    getFechaInicioVigente() {
      if (this.getConveniosPlazo.length === 0) return null;

      // Obtener el convenio más reciente que tenga fechaInicio
      const conveniosConFechaInicio = this.getConveniosPlazo
        .filter((c) => c.fechaInicio)
        .sort((a, b) => {
          const fechaA = a.fecha ? new Date(a.fecha) : new Date(0);
          const fechaB = b.fecha ? new Date(b.fecha) : new Date(0);
          return fechaB - fechaA;
        });

      return conveniosConFechaInicio.length > 0
        ? conveniosConFechaInicio[0].fechaInicio
        : null;
    },
    getFechaTerminoVigente() {
      if (this.getConveniosPlazo.length === 0) return null;

      // Obtener el convenio más reciente que tenga fechaTermino
      const conveniosConFechaTermino = this.getConveniosPlazo
        .filter((c) => c.fechaTermino)
        .sort((a, b) => {
          const fechaA = a.fecha ? new Date(a.fecha) : new Date(0);
          const fechaB = b.fecha ? new Date(b.fecha) : new Date(0);
          return fechaB - fechaA;
        });

      return conveniosConFechaTermino.length > 0
        ? conveniosConFechaTermino[0].fechaTermino
        : null;
    },
    getConveniosMontoAcumulado() {
      const esObraFinanciada = this.contrato?.esObraFinanciada || false;
      return this.getConveniosMonto.reduce((acumulado, convenio) => {
        // Para obra financiada se usa importeCostoDirecto, para obra regular se usa importe
        const importeConvenio = esObraFinanciada
          ? (convenio.importeCostoDirecto || 0)
          : (convenio.importe || 0);

        return {
          importe: acumulado.importe + importeConvenio,
          iva: acumulado.iva + (convenio.iva || 0),
          total: acumulado.total + (convenio.total || 0),
        };
      }, {
        importe: 0,
        iva: 0,
        total: 0,
      });
    },
    getImporteOriginal() {
      if (!this.contrato) return 0;
      // Para obra financiada mostramos el importeCostoDirecto, para regular el importe
      return this.contrato.esObraFinanciada
        ? this.contrato.importeCostoDirecto
        : this.contrato.importe;
    },
    getImporteTotalConConvenios() {
      return this.getImporteOriginal + this.getConveniosMontoAcumulado.importe;
    },
    getIvaTotalConConvenios() {
      return (this.contrato?.iva || 0) + this.getConveniosMontoAcumulado.iva;
    },
    getTotalConConvenios() {
      return (this.contrato?.total || 0) + this.getConveniosMontoAcumulado.total;
    },
    getConveniosFinanciadoAcumulado() {
      return this.getConveniosMonto.reduce((acumulado, convenio) => ({
        importeCostoDirecto:
          acumulado.importeCostoDirecto + (convenio.importeCostoDirecto || 0),
        importeCostoIndirectos:
          acumulado.importeCostoIndirectos + (convenio.importeCostoIndirectos || 0),
        importeUtilidad:
          acumulado.importeUtilidad + (convenio.importeUtilidad || 0),
        importeCargosAdicionales:
          acumulado.importeCargosAdicionales + (convenio.importeCargosAdicionales || 0),
        importeCostoFinanciero:
          acumulado.importeCostoFinanciero + (convenio.importeCostoFinanciero || 0),
      }), {
        importeCostoDirecto: 0,
        importeCostoIndirectos: 0,
        importeUtilidad: 0,
        importeCargosAdicionales: 0,
        importeCostoFinanciero: 0,
      });
    },
    getImporteCostoDirectoConConvenios() {
      return (this.contrato?.importeCostoDirecto || 0)
        + this.getConveniosFinanciadoAcumulado.importeCostoDirecto;
    },
    getImporteCostoIndirectosConConvenios() {
      return (this.contrato?.importeCostoIndirectos || 0)
        + this.getConveniosFinanciadoAcumulado.importeCostoIndirectos;
    },
    getImporteUtilidadConConvenios() {
      return (this.contrato?.importeUtilidad || 0)
        + this.getConveniosFinanciadoAcumulado.importeUtilidad;
    },
    getImporteCargosAdicionalesConConvenios() {
      return (this.contrato?.importeCargosAdicionales || 0)
        + this.getConveniosFinanciadoAcumulado.importeCargosAdicionales;
    },
    getImporteCostoFinancieroConConvenios() {
      return (this.contrato?.importeCostoFinanciero || 0)
        + this.getConveniosFinanciadoAcumulado.importeCostoFinanciero;
    },
    getClaseConvenioCostoDirecto() {
      return this.getConveniosFinanciadoAcumulado.importeCostoDirecto > 0
        ? 'success--text' : 'error--text';
    },
    getColorConvenioCostoDirecto() {
      return this.getConveniosFinanciadoAcumulado.importeCostoDirecto > 0
        ? 'success' : 'error';
    },
    getClaseConvenioCostoIndirectos() {
      return this.getConveniosFinanciadoAcumulado.importeCostoIndirectos > 0
        ? 'success--text' : 'error--text';
    },
    getColorConvenioCostoIndirectos() {
      return this.getConveniosFinanciadoAcumulado.importeCostoIndirectos > 0
        ? 'success' : 'error';
    },
    getClaseConvenioUtilidad() {
      return this.getConveniosFinanciadoAcumulado.importeUtilidad > 0
        ? 'success--text' : 'error--text';
    },
    getColorConvenioUtilidad() {
      return this.getConveniosFinanciadoAcumulado.importeUtilidad > 0
        ? 'success' : 'error';
    },
    getClaseConvenioCargosAdicionales() {
      return this.getConveniosFinanciadoAcumulado.importeCargosAdicionales > 0
        ? 'success--text' : 'error--text';
    },
    getColorConvenioCargosAdicionales() {
      return this.getConveniosFinanciadoAcumulado.importeCargosAdicionales > 0
        ? 'success' : 'error';
    },
    getClaseConvenioCostoFinanciero() {
      return this.getConveniosFinanciadoAcumulado.importeCostoFinanciero > 0
        ? 'success--text' : 'error--text';
    },
    getColorConvenioCostoFinanciero() {
      return this.getConveniosFinanciadoAcumulado.importeCostoFinanciero > 0
        ? 'success' : 'error';
    },
    getEstatus() {
      if (!this.contrato?.estatus) return {};
      return this.contrato.estatus;
    },
    getClaseConvenioImporte() {
      return this.getConveniosMontoAcumulado.importe > 0 ? 'success--text' : 'error--text';
    },
    getColorConvenioImporte() {
      return this.getConveniosMontoAcumulado.importe > 0 ? 'success' : 'error';
    },
    getClaseConvenioIva() {
      return this.getConveniosMontoAcumulado.iva > 0 ? 'success--text' : 'error--text';
    },
    getColorConvenioIva() {
      return this.getConveniosMontoAcumulado.iva > 0 ? 'success' : 'error';
    },
    getClaseConvenioTotal() {
      return this.getConveniosMontoAcumulado.total > 0 ? 'success--text' : 'error--text';
    },
    getColorConvenioTotal() {
      return this.getConveniosMontoAcumulado.total > 0 ? 'success' : 'error';
    },
    getUbicacionesCount() {
      if (!this.contrato?.ubicaciones) return 0;
      return this.contrato.ubicaciones.length;
    },
    getDiasRestantes() {
      // Usar fecha vigente si existe convenio, sino usar fecha original
      const fechaTermino = this.getFechaTerminoVigente || this.contrato?.fechaTermino;
      if (!fechaTermino) return 'Sin fecha';

      const hoy = this.$moment();
      const termino = this.$moment(fechaTermino);
      const dias = termino.diff(hoy, 'days');
      if (dias < 0) return `Venció hace ${Math.abs(dias)} días`;
      if (dias === 0) return 'Vence hoy';
      if (dias === 1) return 'Vence mañana';
      return `${dias} días restantes`;
    },
    getColorDiasRestantes() {
      // Usar fecha vigente si existe convenio, sino usar fecha original
      const fechaTermino = this.getFechaTerminoVigente || this.contrato?.fechaTermino;
      if (!fechaTermino) return 'grey';

      const hoy = this.$moment();
      const termino = this.$moment(fechaTermino);
      const dias = termino.diff(hoy, 'days');
      if (dias < 0) return 'error';
      if (dias <= 7) return 'warning';
      if (dias <= 30) return 'info';
      return 'success';
    },
  },
};
</script>

<style lang="scss">

</style>
